import { getRelativeTimeBucket } from "@shared/widgets/relativeTime";
import type { Translator } from "../i18n/resolve";

export const relativeTime = (
  timestamp: number,
  translate: Translator,
  now: number = Date.now(),
): string => {
  const bucket = getRelativeTimeBucket(timestamp, now);
  if (bucket.key === "relativeJustNow") return translate("relativeJustNow");
  return translate(bucket.key, { count: bucket.count });
};
